module.exports = __webpack_public_path__ + "img/menu5.a0383616.png";